import React from "react";
const ArrowRightThin = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M408.96 223.04L697.95200001 512l-288.99200001 288.96-33.92000001-33.92L630.04800001 512l-255.00800002-255.04z" />
  </svg>
);
export default ArrowRightThin;
